import { Button, CardBackground, Typography } from "@hellocarbo/lasagne";
import { LucideIcon } from "lucide-react";

import useSegmentEvent from "@/hooks/useSegmentEvent";

type AdditionalModuleProps = {
  Icon: LucideIcon;
  title: string;
  text?: string;
  segmentEventName: string;
  ctaText?: string;
  ctaHref?: string;
  isInternal?: boolean;
};

function AdditionalModule({
  Icon,
  title,
  text,
  segmentEventName,
  ctaText,
  ctaHref,
  isInternal = false,
}: AdditionalModuleProps) {
  const { sendSegmentEvent } = useSegmentEvent();

  return (
    <CardBackground className="border-grayscale-xx-light rounded-lg border">
      <div className="gap-y-sm flex flex-col">
        <Icon className="size-lg text-grayscale-light self-center" />
        <div>
          <Typography as="h3" weight="bold" className="mb-2xs">
            {title}
          </Typography>
          <Typography step="-1" className="text-grayscale">
            {text}
          </Typography>
        </div>
      </div>
      <div className="mt-md flex justify-center">
        <Button
          as="a"
          href={ctaHref}
          intent="secondary"
          shape="soft"
          shouldOpenNewTab={!isInternal}
          size="small"
          onClick={() => sendSegmentEvent(segmentEventName)}
        >
          {ctaText}
        </Button>
      </div>
    </CardBackground>
  );
}

export default AdditionalModule;
